<i18n>
{
"ru": {
"reviews_one": "оценка",
"reviews_few": "оценки",
"reviews_many": "оценок",
"comments_one": "отзыв",
"comments_few": "отзыва",
"comments_many": "отзывов"
}
}
</i18n>
<template>
    <div class="rating-and-reviews">
        <div class="rating-and-reviews__rating">
            <div class="rating-and-reviews__rating-count">{{ ratingInternal | numberFormatRating }}</div>
            <div class="rating-and-reviews__rating-stars rating"
                :data-value="rating | numberFormatRatingHalf">
            </div>
        </div>

        <div class="rating-and-reviews__text">
            <span>{{ reviews | numberDeclension(reviewsDeclension)}}</span>
            /

            <a @click.prevent="scrollToComments" href="#comments">{{ comments | numberDeclension(commentsDeclension)}}</a>
        </div>
    </div>
</template>

<script>

export default {
    name: 'RatingAndReviews',
    inheritAttrs: false,
    props: {
        rating: {
            type: [Number, String],
            default: -1
        },
        reviews: {
            type: [Number, String],
            default: 0
        },
        comments: {
            type: [Number, String],
            default: 0
        }
    },
    computed: {
        commentsDeclension() {
            return [
                this.$t('comments_one'),
                this.$t('comments_few'),
                this.$t('comments_many')
            ]
        },
        reviewsDeclension() {
            return [
                this.$t('reviews_one'),
                this.$t('reviews_few'),
                this.$t('reviews_many')
            ]
        },
        ratingInternal: {
            get() {
                return this.rating
            },
            set(value) {
                this.$emit('change', value)
            }
        },
    },
    methods: {
        scrollToComments() {
            this.$bus.$emit('on-scroll-to-comments');
            this.$emit('on-scroll-to-comments');
        },
    }
}
</script>

<style lang="less">
.rating-and-reviews {
    color: @color-gray;

    &__text {
        font-size: rem(13);

        margin-top: rem(9);
        padding-right: rem(14);

        @{desktop} & {
            margin-top: rem(12);
        }

        span {
            padding-right: rem(4);
        }

        a {
            padding-left: rem(3);

            .hover({
                color: @color-black;
            });
        }
    }

    a {
        color: inherit;
        text-decoration: underline;

        position: relative;

        &:after {
            --size: rem(12);

            content: '';
            display: block;

            background-image: url('/sprite/svg/chevron-down-grey.svg');
            background-repeat: no-repeat;

            height: var(--size);
            width: var(--size);

            position: absolute;
            top: 50%;
            right: rem(-16);

            transform: translateY(-50%);
        }
    }

    &__rating {
        display: flex;
        align-items: center;
        justify-content: center;

        @{desktop} & {
            flex-direction: row-reverse;
            margin-left: rem(-3.5);
        }

        &-count {
            display: inline-flex;
            align-items: center;
            justify-content: center;

            color: @color-black;
            font-size: rem(20);
            font-weight: 500;
            line-height: 1;

            margin-right: rem(6);

            /* фикс шрифта */
            padding-top: rem(5.5);

            height: rem(28);
            width: rem(30);

            @{desktop} & {
                font-size: rem(22);

                margin-left: rem(8);
            }
        }

        &-stars {
            --star-width: rem(21);
            --star-height: rem(18);
        }
    }
}
</style>
